<mat-card class="tickets-page-card">
    <app-ticket-search-panel
        (search)="onSearchFilters($event)"
        (clear)="onClearFilters()"
    >
    </app-ticket-search-panel>

    <app-ticket-statistics
        [statisticLoaded]="statisticLoaded"
        [statisticsData]="statisticsSource?.data || []"
        [periodStart]="getPeriodStartDate()"
        [periodEnd]="getPeriodEndDate()"
        [showUserFilter]="showUserUuid"
        [userUuid]="userUuid"
        (refreshData)="refreshData()"
    >
    </app-ticket-statistics>

    <div class="tickets-container">
        <mat-card class="table-card">
            <div class="table-header">
                <mat-paginator
                    #paginator
                    [length]="totalCount"
                    [pageSize]="numberOfRows"
                    [pageSizeOptions]="[25, 50, 100, 200]"
                    [showFirstLastButtons]="true"
                    (page)="onPageChange($event)"
                    class="table-paginator-top"
                >
                </mat-paginator>
            </div>

            <div class="mat-table-holder">
                <!-- Loading overlay -->
                <div
                    class="loading-statistics"
                    *ngIf="loading"
                >
                    <mat-icon class="loading-icon">hourglass_empty</mat-icon>
                    <span>Loading tickets...</span>
                </div>

                <table
                    mat-table
                    [dataSource]="dataSource"
                    matSort
                    matSortDisableClear
                    (matSortChange)="sortChanged($event)"
                    [multiTemplateDataRows]="true"
                    appMatTableFocusKeyManager
                    class="mat-elevation-z8 expandable-table"
                    [class.hidden]="loading"
                >
                    <!-- Status -->
                    <ng-container matColumnDef="status">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >
                            Status
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            class="status-cell"
                        >
                            <span
                                class="status-badge"
                                [ngClass]="{
                                    'status-won': element.isWon === 1,
                                    'status-lost': element.isWon === 0,
                                    'status-unknown':
                                        element.isWon === null ||
                                        element.isWon === undefined
                                }"
                            >
                                <mat-icon class="status-icon">
                                    {{
                                        element.isWon === 1
                                            ? 'check_circle'
                                            : element.isWon === 0
                                              ? 'cancel'
                                              : 'help_outline'
                                    }}
                                </mat-icon>
                                <span class="status-text">
                                    {{
                                        element.isWon === 1
                                            ? 'Won'
                                            : element.isWon === 0
                                              ? 'Lost'
                                              : 'Unknown'
                                    }}
                                </span>
                            </span>
                        </td>
                    </ng-container>

                    <!-- Ticket UUID -->
                    <ng-container matColumnDef="ticket_uuid">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >
                            TicketUuid
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                        >
                            {{ element.ticketUuid }}
                        </td>
                    </ng-container>

                    <!-- Payin Time -->
                    <ng-container matColumnDef="payin_time">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >
                            Payin Time
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                        >
                            {{
                                element.payinTime
                                    | dateTimeZone
                                        : currentTimeZone
                                        : 'yyyy-MM-dd HH:mm:ss'
                            }}
                        </td>
                    </ng-container>

                    <!-- Payout Time -->
                    <ng-container matColumnDef="payout_time">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >
                            Payout Time
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                        >
                            {{
                                element.payoutTime | date: 'yyyy-MM-dd HH:mm:ss'
                            }}
                        </td>
                    </ng-container>

                    <!-- CCY -->
                    <ng-container matColumnDef="ccy">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >
                            CCY
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                        >
                            {{ element.ccy }}
                        </td>
                    </ng-container>

                    <!-- Exchange Rate -->
                    <ng-container matColumnDef="exchange_rate">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >
                            XR
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                        >
                            {{ element.ccyRate | number: '1.0-18' }}
                        </td>
                    </ng-container>

                    <!-- Payin (Player) -->
                    <ng-container matColumnDef="payin">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >
                            Payin (Player)
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                        >
                            {{ element.payin | number: '1.0-18' }}
                        </td>
                    </ng-container>

                    <!-- Payin (BASE) -->
                    <ng-container matColumnDef="payin_base">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >
                            Payin (BASE)
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                        >
                            {{ element.payinBase | number: '1.0-18' }}
                        </td>
                    </ng-container>

                    <!-- Payout (Player) -->
                    <ng-container matColumnDef="payout">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >
                            Payout (Player)
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                        >
                            {{
                                element.isWon === 0
                                    ? 0
                                    : (element.payout | number: '1.0-18')
                            }}
                        </td>
                    </ng-container>

                    <!-- Payout (BASE) -->
                    <ng-container matColumnDef="payout_base">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >
                            Payout (BASE)
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                        >
                            {{
                                element.isWon === 0
                                    ? 0
                                    : (element.payoutBase | number: '1.0-18')
                            }}
                        </td>
                    </ng-container>

                    <!-- User UUID -->
                    <ng-container matColumnDef="user_uuid">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                        >
                            UserUuid
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                        >
                            {{ element.userUuid }}
                        </td>
                    </ng-container>

                    <!-- Header -->
                    <tr
                        mat-header-row
                        *matHeaderRowDef="displayedColumns; sticky: true"
                    ></tr>

                    <!-- Main data row -->
                    <tr
                        mat-row
                        *matRowDef="let row; columns: displayedColumns"
                        (click)="toggleRow(row, $event)"
                        [ngClass]="{
                            selectedRow: row.selected === true && !darkMode,
                            darkSelectedRow: row.selected === true && darkMode,
                            'expanded-row-active': isRowExpanded(row),
                            'ticket-won': row.isWon === 1,
                            'ticket-lost': row.isWon === 0,
                            'ticket-unknown':
                                row.isWon === null || row.isWon === undefined
                        }"
                        style="cursor: pointer"
                    ></tr>

                    <!-- Expandable detail row -->
                    <ng-container matColumnDef="expandedDetail">
                        <td
                            mat-cell
                            *matCellDef="let row"
                            [attr.colspan]="displayedColumns.length"
                            class="expanded-detail-cell"
                        >
                            <app-ticket-details
                                [isExpanded]="isRowExpanded(row)"
                                [ticketRow]="row"
                                [ticketDetails]="
                                    ticketDetailsMap.get(row.ticketUuid)
                                "
                                [loading]="loadingDetails.has(row.ticketUuid)"
                                [error]="errorStates.get(row.ticketUuid)"
                                (onRetry)="getTicketDetailsForRow(row)"
                            ></app-ticket-details>
                        </td>
                    </ng-container>

                    <!-- Detail row -->
                    <tr
                        mat-row
                        *matRowDef="let row; columns: ['expandedDetail']"
                        class="detail-row"
                        [class.expanded]="isRowExpanded(row)"
                        [style.display]="isRowExpanded(row) ? '' : 'none'"
                    ></tr>
                </table>
            </div>
        </mat-card>
    </div>
</mat-card>
